import React from 'react';
import { SearchInput } from '@ui/general';
import { UpdateQueryParams } from '@hooks';

export type SearchFilterQueryParams = { query?: string };

export interface SearchFilterProps {
	onChange: UpdateQueryParams<SearchFilterQueryParams>;
}

export const SearchFilter: React.FC<SearchFilterProps> = ({ onChange }) =>
	<SearchInput onChange={ (query = '') => onChange({ query }) } />;
